import { useCallback } from 'react'
import { AjvError } from '@rjsf/core'

export const useCustomErrorMessagesMapper = () => {
  const getErrorDomain = (errorPath: string) => {
    const pathArray: string[] = errorPath.split('.')

    return pathArray[pathArray.length - 1]
  }

  return useCallback((errors: AjvError[]) => {
    const transformedErrors = errors?.map((error: AjvError) => {
      switch (getErrorDomain(error.property)) {
        case 'transferredNcdCarPlate':
          error.message =
            'trans__insurance__insapp_insurance_form__transferred_ncd_car_no_plate_error_message'
          break
        default:
          error.message =
            'trans__insurance__insapp_insurance_form__required_field_message'
          break
      }

      return error
    })
    // Filter needed to prevent all errors appearing in composite (object) fields
    return transformedErrors.filter(error => error.name !== 'enum')
  }, [])
}
